import styled from 'styled-components';

export const PortfolioVolatility = styled('div')`
  position: relative;
  height: 135px;
  font-size: ${(props) => props.theme.x1space + 0.4}rem;
  font-weight: 700;
  abbr {
    text-decoration: none;
  }
`;

export const MarketMarker = styled('div')`
  position: absolute;
  left: 50%;
  bottom: 30px;
  z-index: 0;
  span {
    background: #d0cece;
    padding: 2px;
    border-radius: 2px;
    white-space: nowrap;
    color: #334252;
    &:after {
      border-bottom: 5px solid;
      border-bottom-color: inherit;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      content: '';
      position: absolute;
      margin-left: -5px;
      left: 50%;
      top: -7px;
    }
  }
`;

export const UpperMarker = styled('div')`
  position: absolute;
  top: -24px;
  z-index: 0;
  span {
    background: #33c3f0;
    padding: 2px;
    border-radius: 2px;
    white-space: nowrap;
    color: #334252;
    &:after {
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid #33c3f0;
      content: '';
      position: absolute;
      margin-left: -5px;
      left: 50%;
      bottom: -7px;
    }
  }
`;

export const LowerMarker = styled('div')`
  position: absolute;
  top: 11px;
  z-index: 0;
  span {
    background: #d0cece;
    padding: 2px;
    border-radius: 2px;
    white-space: nowrap;
    color: #334252;
    &:after {
      border-bottom: 5px solid;
      border-bottom-color: inherit;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      content: '';
      position: absolute;
      margin-left: -5px;
      left: 50%;
      top: -7px;
    }
  }
`;

export const InnerMarker = styled('div')`
  transform: translateX(-50%);
`;

export const VolatilityGauge = styled('div')`
  max-width: 600px;
  margin: 20px auto 0px auto;
`;

export const Gauge = styled('div')`
  position: absolute;
  top: 30px;
  min-width: 240px;
  width: 100%;
  padding: 0 24px;
  z-index: 0;
  svg {
    * {
      fill: white;
    }
    width: 16px;
    height: 16px;
  }
`;

export const InnerGauge = styled('div')`
  position: relative;
  background: #d0cece;
  height: 2px;
  &:after {
    position: absolute;
    content: '';
    display: block;
    height: 60px;
    width: 1px;
    background: #d0cece;
    left: 50%;
  }
`;

export const Bed = styled('div')`
  position: absolute;
  top: -8px;
  left: 0;
`;

export const Bolt = styled('div')`
  position: absolute;
  top: -8px;
  right: 0;
`;
